<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      activityStatus
      @handleSearch="getData"
      btn-add
      @handleAdd="handleAdd"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <!-- <el-table-column label="宣传图" align="center" width="130">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 120px;"
            :src="serverUrl + scope.row.image"
            :preview-src-list="getImgPreviewList(scope.row.image)"
          ></el-image>
        </template>
      </el-table-column> -->
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row)"
            type="text"
            size="mini"
          >
            详情
          </el-button>
          <el-button
            @click="handleBackStep(scope.row, 0)"
            type="text"
            v-if="scope.row.status === 1"
            size="mini"
          >
            撤回
          </el-button>
          <el-button
            @click="handleBackStep(scope.row, 1)"
            type="text"
            v-if="scope.row.status === 0"
            size="mini"
          >
            提交
          </el-button>
          <el-button
            @click="handleEdit(scope.row)"
            type="text"
            v-if="scope.row.status === 0"
            size="mini"
          >
            编辑
          </el-button>

          <el-button
            @click="handleAudit(scope.row)"
            type="text"
            v-if="scope.row.status === 3"
            size="mini"
          >
            报名审核
          </el-button>
          <el-button
            @click="handleFinish(scope.row)"
            type="text"
            v-if="
              scope.row.status === 5 ||
                scope.row.status === 2 ||
                scope.row.status === 3 ||
                scope.row.status === 4
            "
            size="mini"
          >
            结束
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            v-if="scope.row.status === 0 || scope.row.status === 6"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[4, 10, 20, 30]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加志愿者活动"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="活动名称" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="活动名称"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item
          label="活动封面"
          style="text-align: left"
          prop="image"
          label-width="100px"
        >
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="overwriteDefault"
          >
            <img
              v-if="form.image"
              :src="serverUrl + form.image"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <p>点击上传</p>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item> -->
        <el-form-item label="活动内容" label-width="100px" prop="content">
          <quill-editor
            style="text-align: left;"
            v-model="form.content"
            ref="myQuillEditor"
            :options="editorOption"
            @focus="onEditorFocus($event)"
            @blur="onEditorBlur($event)"
            @change="onEditorChange($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item label="活动地址" prop="address" label-width="100px">
          <el-input
            v-model="form.address"
            size="medium"
            placeholder="活动地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile" label-width="100px">
          <el-input
            v-model="form.mobile"
            size="medium"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名开始" label-width="100px" prop="startSignTime">
          <el-date-picker
            v-model="form.startSignTime"
            type="datetime"
            style="width: 100%;"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择报名开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="报名结束" label-width="100px" prop="endSignTime">
          <el-date-picker
            v-model="form.endSignTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            style="width: 100%;"
            placeholder="选择报名结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所需人数" label-width="100px" prop="number">
          <el-input
            v-model="form.number"
            size="medium"
            type="number"
            min="0"
            placeholder="请输入所需人数"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动积分" label-width="100px" prop="score">
          <el-input
            v-model="form.score"
            size="medium"
            type="number"
            min="0"
            placeholder="请输入活动给与积分"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="活动开始"
          label-width="100px"
          prop="activityTimeStart"
        >
          <el-date-picker
            v-model="form.activityTimeStart"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            style="width: 100%;"
            placeholder="选择活动开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="活动结束"
          label-width="100px"
          prop="activityTimeEnd"
        >
          <el-date-picker
            v-model="form.activityTimeEnd"
            value-format="yyyy-MM-dd HH:mm"
            type="datetime"
            style="width: 100%;"
            placeholder="选择活动结束时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button @click="dialogConfirm(0)">存为草稿</el-button>
        <el-button type="primary" @click="dialogConfirm(1)">提交审核</el-button>
      </div>
    </el-dialog>

    <!--审核Dialog-->
    <el-dialog
      title="审核参加者"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogAuditVisible"
    >
      <el-table :data="volunteersData" border>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in volunteersHeader"
          :key="index"
          :label="item"
          :prop="index"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              @click="auditVolunteers(scope.row, 1)"
              type="text"
              :disabled="scope.row.status === 1"
              size="mini"
            >
              通过
            </el-button>
            <el-button
              @click="auditVolunteers(scope.row, 2)"
              type="text"
              :disabled="scope.row.status === 2"
              style="color:red"
              size="mini"
            >
              驳回
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAuditVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 紧急停止活动 -->
    <el-dialog title="紧急停止活动" :visible.sync="stopActive">
      <div>
        是否下发活动积分：
        <el-switch
          v-model="hasActiveScore"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="stopActive = false">关闭</el-button>
        <el-button @click="stopActiveFun">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :visible.sync="dialogContentVisible"
    >
      <Details :detail="dialogContent" :type="'active'"></Details>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Details from "@/components/details/index"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { quillEditor } from "vue-quill-editor"
import "quill/dist/quill.snow.css"
import { quillRedefine } from "vue-quill-editor-upload"
import qs from "qs"
export default {
  name: "activityManager",
  components: {
    quillEditor,
    quillRedefine,
    Details,
  },
  data() {
    let Self = this

    // 表单验证
    let validate = (rule, value, callback) => {
      if (!!value) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("数据填写不完整"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      currentElements: 10,
      totalPages: 1,
      size: 4,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        gender: "",
        idCard: "",
        mobile: "",
        family: "",
        street: "",
        education: "",
        activityStatus: "",
      },

      // 表头初始化
      tableHeader: {
        name: "活动名称",
        startSignTime: "报名开始",
        endSignTime: "报名结束",
        number: "参加人数",
        score: "积分",
        activityTimeStart: "活动开始",
        activityTimeEnd: "活动结束",
        statusName: "状态",
      },
      volunteersHeader: {
        name: "姓名",
        genderName: "性别",
        mobile: "手机号",
        idCard: "身份证号",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],
      volunteersData: [
        {
          name: "name",
          status: "未处理",
        },
        {
          name: "name",
          status: "未处理",
        },
        {
          name: "name",
          status: "未处理",
        },
        {
          name: "name",
          status: "未处理",
        },
      ],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,
      dialogAuditVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        name: "",
        // image: "",
        content: "",
        address: "",
        mobile: "",
        startSignTime: "",
        endSignTime: "",
        number: "",
        score: "",
        activityTimeStart: "",
        activityTimeEnd: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        image: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        content: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        address: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        startSignTime: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        endSignTime: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        number: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        score: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        activityTimeStart: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
        activityTimeEnd: {
          required: true,
          validator: validate,
          trigger: "blur",
        },
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      stopActive: false,
      stopActiveUid: "",
      hasActiveScore: false,
      disabled: false,

      dialogContentVisible: false,
      dialogContent: "",

      // 编辑器配置
      editorOption: {
        placeholder: "请详细填写活动内容",
        modules: {
          toolbar: [
            "bold",
            "italic",
            "underline",
            "strike",
            "align",
            "link",
            "image",
          ],
        },
      },

      // 地图配置
      center: "成都市",
      addressKeyword: "",
      geolocation: {},
      keyword: "",

      // 当前选择的活动
      currentActityUid: "",
    }
  },
  methods: {
    /*地图相关处理
     * */

    mapClick(e) {
      this.center = {
        lng: e.point.lng,
        lat: e.point.lat,
      }
    },

    handler({ BMap, map }) {
      this.center = {
        lng: map.re.lng,
        lat: map.re.lat,
      }
      this.form.latitude = map.re.lng
      this.form.longitude = map.re.lat
    },

    /*图片预览
     * */
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/activity/findActivity",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          status: this.searchForm.activityStatus,
          name: this.searchForm.name,
          activityStartTimeStart: this.searchForm.activityStartTimeStart,
          activityStartTimeEnd: this.searchForm.activityStartTimeEnd,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.currentElements = res.data.data.currentElements

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*根据活动查询志愿者
     * */
    getVolunteers(uid) {
      this.request({
        url: "/manager/activity/findVolunteers",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          uid: uid,
        },
      })
        .then(res => {
          this.volunteersData = res.data.data.content
          this.dialogAuditVisible = true
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/activity/updateStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*审核参加人员
     * */
    handleAudit(rowData) {
      this.currentActityUid = rowData.uid
      this.getVolunteers(this.currentActityUid)
    },
    //
    handleBackStep(rowData, status) {
      this.$confirm("确认进行该操作?")
        .then(() => {
          this.request({
            url: "/manager/activity/updateStatus",
            data: {
              uid: rowData.uid,
              status: status,
            },
            method: "post",
          })
            .then(res => {
              this.$message.success("操作成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }

      this.dialogFormVisible = true
      this.center = {
        lng: this.form.longitude,
        lat: this.form.latitude,
      }
    },

    /*结束
     * */
    handleFinish(rowData) {
      this.stopActiveUid = rowData.uid
      this.stopActive = true
    },
    stopActiveFun() {
      this.request({
        url: "/manager/activity/updateStatus",
        data: {
          uid: this.stopActiveUid,
          status: 6,
          sendScore: this.hasActiveScore,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
          this.stopActive = false
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*添加操作
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/activity/deleteActivity",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交
     * type:
     *   0 草稿
     *   1 待发布
     * */
    dialogConfirm(type) {
      this.$refs.form.validate(valid => {
        if (type === 0) {
          valid = true
        }

        if (valid) {
          this.request({
            url: "/manager/activity/addOrUpdateActivity",
            data: {
              uid: this.form.uid,
              address: this.form.address,
              status: type,
              mobile: this.form.mobile,
              name: this.form.name,
              // image: this.form.image,
              content: this.form.content,
              startSignTime: this.form.startSignTime,
              endSignTime: this.form.endSignTime,
              number: this.form.number,
              score: this.form.score,
              activityTimeStart: this.form.activityTimeStart,
              activityTimeEnd: this.form.activityTimeEnd,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
                this.dialogFormVisible = true
              }

              this.getData()
              this.dialogFormVisible = false
              // this.form = {}
              this.dialogCancel()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      this.form = {
        uid: "",
        name: "",
        image: "",
        content: "",
        address: "",
        mobile: "",
        startSignTime: "",
        endSignTime: "",
        number: "",
        score: "",
        activityTimeStart: "",
        activityTimeEnd: "",
      }
      this.center = {}
      this.dialogFormVisible = false
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "volunteer")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          this.form.image = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },

    /*审核参加人
     * */
    auditVolunteers(rowData, type) {
      this.$prompt("输入审核缘由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.request({
            url: "/manager/activity/auditVolunteers",
            data: {
              uid: rowData.uid,

              status: type,
              reason: value,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }
              this.getVolunteers(this.currentActityUid)
            })
            .catch(err => {
              this.$message.error(err.message)
            })

          this.$message({
            type: "success",
            message: "操作成功",
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          })
        })
    },

    showDialogContent(rowData) {
      this.dialogContentVisible = true
      this.dialogContent = rowData
    },
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    this.editor = null
    delete this.editor
  },
  created() {
    let token = localStorage.getItem("token")
    this.editorOption = quillRedefine({
      // 图片上传的设置
      uploadConfig: {
        action: apiUrl.server + "/manager/upload/uploadPic", // 必填参数 图片上传地址
        // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
        // 你必须把返回的数据中所包含的图片地址 return 回去
        name: "file",
        res: respnse => {
          console.log(apiUrl.server.split("/api")[0] + respnse.data)
          return apiUrl.server.split("/api")[0] + respnse.data // 这里切记要return回你的图片地址
        },
        header: (xhr, formData) => {
          xhr.setRequestHeader("Authorization", token)
          formData.append("uid", this.form.uid)
        },
      },
    })
  },
}
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 150px;
  object-fit: cover;
  display: block;
}
</style>
